import React from 'react';
import './aboutinfo.scss';

const AboutInfoSection = () => {
  return (
    <section className="store-info-section">

      <div className="image-content">
        <img src="images/about/shopimg.png" alt="Store" />
      </div>
      <div className="text-content">
        <h2>Our Values</h2>
        <p>Thorough experience of 82 years, we now believe that an unprecedented service and the quality of the product are two most critical and irreplaceable values when it comes to the Gold business. Which is why customers not only from Satara but also from the nearby cities like Sangli, Kolhapur, Pune and from Konkan area visit us when they crave for Gold.

        </p>
      </div>
    </section>
  );
};

export default AboutInfoSection;
